import {
  getUserRole,
  getUserUid,
  getUsername,
} from "../../utils/tokenHandlers";

const UidEmailRoleMatch = () => {
  const userRole = getUserRole();
  const userId = getUserUid();
  const userEmail = getUsername();
  return {
    uid: userId,
    email: userEmail,
    role: userRole,
  };
};

export default UidEmailRoleMatch;
